import React from 'react';
import { string, arrayOf } from 'prop-types';
import { Box, Typography, SvgIcon } from '@mui/material';
import { I18n } from 'utils/i18n';
import LocationIcon from 'assets/icons/location.svg';
import PhoneIcon from 'assets/icons/phone.svg';
import EmailIcon from 'assets/icons/mail.svg';
import TagsIcon from 'assets/icons/tags.svg';

const InfoList = ({ location = null, phone = null, email = null, tags = null }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      paddingLeft: '100px',
      marginBottom: '50px',
    }}
  >
    <Typography
      sx={{
        display: 'flex',
        alignItems: 'center',
        minHeight: 40,
      }}
    >
      <SvgIcon sx={{ fontSize: 20, marginRight: '10px', color: 'secondary.dark' }}>
        <LocationIcon />
      </SvgIcon>
      {location || I18n.t('ProfileDrawer.no data')}
    </Typography>
    <Typography
      sx={{
        display: 'flex',
        alignItems: 'center',
        minHeight: 40,
      }}
    >
      <SvgIcon sx={{ fontSize: 20, marginRight: '10px', color: 'secondary.dark' }}>
        <PhoneIcon />
      </SvgIcon>
      {phone || I18n.t('ProfileDrawer.no data')}
    </Typography>
    <Typography
      sx={{
        display: 'flex',
        alignItems: 'center',
        minHeight: 40,
      }}
    >
      <SvgIcon sx={{ fontSize: 20, marginRight: '10px', color: 'secondary.dark' }}>
        <EmailIcon />
      </SvgIcon>
      {email || I18n.t('ProfileDrawer.no data')}
    </Typography>
    <Typography
      sx={{
        display: 'flex',
        alignItems: 'center',
        minHeight: 40,
      }}
    >
      <SvgIcon sx={{ fontSize: 20, marginRight: '10px', color: 'secondary.dark' }}>
        <TagsIcon />
      </SvgIcon>
      {tags?.join(',') || I18n.t('ProfileDrawer.no data')}
    </Typography>
  </Box>
);
InfoList.propTypes = {
  location: string,
  phone: string,
  email: string,
  tags: arrayOf(string),
};

export default InfoList;
